/**
 * App Warning Theme
 */
import {createMuiTheme} from '@material-ui/core/styles';
import AppConfig from '../../config/AppConfig';
import overrideStyles from './overrideStyles';

const theme = createMuiTheme({
    palette: {
        primary: {
            main: AppConfig.themeColors.warning,
        },
        secondary: {
            main: AppConfig.themeColors.primary,
        },
    },
    overrides: {
        ...overrideStyles,
    },
});

export default theme;
